import type { ResourceLanguage } from "i18next";

import { Tk } from "../translation-key";
import { tk } from "../utils";

const RESOURCES = {
  translation: {
    EN: "engl",
    UK: "ukr",
    DE: "de",
    SK: "slov",
    RU: "rus",
    ENGLISH: "englisch",
    UKRAINIAN: "ukrainisch",
    GERMAN: "deutsch",
    SLOVAK: "slowakisch",
    RUSSIAN: "russisch",
    ORDER_ACCEPTANCE: "Auftragsannahme",
    INTRODUCTION: "Einführung",
    CALCULATOR: "Kalkulator",
    PROFESSIONAL_RELOCATION_SERVICES_IN_SWITZERLAND:
      "Professionelle Relocation Services in der Schweiz",
    RELIABLE_LOADERS_EXPERIENCED_DRIVERS_AND_THE_BEST_PRICE_ON_THE_MARKET:
      "zuverlässige Lader, erfahrene Fahrer und der beste Preis auf dem Markt",
    CALCULATE_THE_COST: "Berechnen Sie die Kosten",
    SUPPORT: "Unterstützung",
    RELIABLE_SERVICE: "zuverlässiger Service",
    WHY_CUSTOMERS_CHOOSE_US: "warum Kunden uns wählen",
    FAVORABLE_PRICES: "erschwingliche Preise",
    THE_BEST_PRICES_ON_THE_MARKET_WITHOUT_HIDDEN_FEES:
      "die besten Preise auf dem Markt ohne versteckte Gebühren",
    FAST_CAR_DELIVERY: "schnelle Autolieferung",
    TRANSPORT_WILL_ARRIVE_WITHIN_30_60_MINUTES:
      "Der Transport wird innerhalb von 30-60 Minuten eintreffen",
    EXPERIENCED_LOADERS: "erfahrene Lader",
    QUALIFIED_EMPLOYEES_WITH_EXTENSIVE_WORK_EXPERIENCE:
      "qualifizierte Mitarbeiter mit langjähriger Berufserfahrung",
    GUARANTEE_OF_PRESERVATION: "Garantie der Erhaltung",
    YOUR_BELONGINGS_ARE_SAFE_THROUGHOUT_THE_MOVE:
      "Ihr Hab und Gut ist während des gesamten Umzugs sicher",
    OUR_SERVICES: "Unsere Dienstleistungen",
    WE_OFFER_A_FULL_RANGE_OF_SERVICES_FOR_MOVING_APARTMENTS_OFFICES_AND_INDUSTRIAL_FACILITIES:
      "Wir bieten umfassende Dienstleistungen für den Umzug von Wohnungen, Büros und Industrieanlagen",
    APARTMENT_MOVING: "Wohnungsumzug",
    OFFICE_RELOCATION: "Büroumzug",
    INDUSTRIAL_RELOCATION: "Industrieverlagerung",
    MORE_DETAILS: "mehr Details",
    MOVING_COST: "Umzugskosten",
    FLEXIBLE_PRICING_SYSTEM_FOR_DIFFERENT_ORDERS:
      "flexibles Preissystem für unterschiedliche Bestellungen",
    MINIMUM: "Minimum",
    FROM_PRICE: "ab {{price}}",
    CARGO_GAZELLE: "Frachtgazelle",
    TRUCK: "LKW",
    T: "t",
    NUMBER_OF_LOADERS: "Anzahl der Lader",
    POPULAR: "beliebt",
    PRICE_FOR_A_1_ROOM_APARTMENT: "Preis für eine 1-Zimmer-Wohnung",
    PRICE_FOR_A_HOUSE_WITH_AN_AREA_OF_UP_TO_100_M:
      "Preis für ein Haus mit einer Fläche von bis zu 100 m²",
    PRICE_FOR_AN_OFFICE_WITH_AN_AREA_OF_UP_TO_50_M:
      "Preis für ein Büro mit einer Fläche von bis zu 50 m²",
    ORDER: "Bestellung",
    [tk(Tk.ORDER, { plural: "one" })]: "Bestellung",
    [tk(Tk.ORDER, { plural: "other" })]: "Bestellungen",
    COST_CALCULATOR: "Kostenrechner",
    CALCULATE_THE_COST_OF_YOUR_MOVE: "Berechnen Sie die Kosten Ihres Umzugs",
    SELECT_SERVICES: "Dienste auswählen",
    TRANSPORTATION: "Transport",
    PACKING_THINGS: "Sachen packen",
    LOADING_UNLOADING: "Be-/Entladen",
    VEHICLE: "Fahrzeug",
    YOUR_ORDER: "Ihre Bestellung",
    TOTAL: "gesamt",
    OUR_CUSTOMERS_REVIEWS: "Bewertungen unserer Kunden",
    HOW_DO_WE_WORK: "Wie wir arbeiten",
    PREPARATION: "Vorbereitung",
    MOVING: "Umzug",
    YOU_LEAVE_A_REQUEST_ON_THE_WEBSITE_OR_CALL_OUR_MANAGER_WILL_CONTACT_YOU_WITHIN_15_MINUTES:
      "Sie hinterlassen eine Anfrage auf der Website oder rufen an. Unser Manager wird Sie innerhalb von 15 Minuten kontaktieren",
    WE_CALCULATE_THE_COST_AGREE_ON_A_TIME_BRING_PACKING_MATERIALS_AND_PREPARE_THE_TEAM:
      "Wir kalkulieren die Kosten, vereinbaren einen Termin, bringen Verpackungsmaterial mit und bereiten das Team vor",
    OUR_SPECIALISTS_ARRIVE_AT_THE_APPOINTED_TIME_CAREFULLY_PACK_LOAD_AND_TRANSPORT_YOUR_BELONGINGS:
      "Unsere Spezialisten kommen pünktlich zum vereinbarten Termin, verpacken, verladen und transportieren Ihr Hab und Gut sorgfältig",
    CONTACT_US: "Kontaktieren Sie uns",
    ADDRESS: "Adresse",
    [tk(Tk.ADDRESS, { plural: "one" })]: "Adresse",
    [tk(Tk.ADDRESS, { plural: "other" })]: "Adressen",
    PHONE: "Telefon",
    [tk(Tk.PHONE, { plural: "one" })]: "Telefon",
    [tk(Tk.PHONE, { plural: "other" })]: "Telefone",
    EMAIL: "E-Mail",
    WORK_SCHEDULE: "Arbeitszeitplan",
    SOCIAL_NETWORKS: "soziale Netzwerke",
    WRITE_TO_US: "Schreiben Sie uns",
    REQUEST_SUBJECT: "Gegenstand der Anfrage",
    I_D_LIKE_TO_ORDER: "Ich möchte gerne bestellen",
    QUESTIONS_ABOUT_SERVICES: "Fragen zu Dienstleistungen",
    OTHER: "andere",
    MESSAGE: "Nachricht",
    SEND: "senden",
    CONVENIENT_FAST_RELIABLE: "bequem, schnell, zuverlässig",
    ALL_RIGHTS_RESERVED: "Alle Rechte vorbehalten",
    THERE_WAS_AN_ERROR_LOADING_DATA: "Beim Laden der Daten ist ein Fehler aufgetreten",
    TRY_AGAIN: "versuchen Sie es erneut",
    ORDER_A_MOVE: "einen Umzug bestellen",
    CONTACT_PERSON: "Ansprechpartner",
    FULL_NAME: "vollständiger Name",
    CITY: "Stadt",
    FLOOR: "Stock",
    IS_THERE_AN_ELEVATOR: "Gibt es einen Aufzug",
    DESCRIPTION_OF_CARGO: "Beschreibung der Ladung",
    FROM_WHERE: "woher",
    TO: "wohin",
    SEND_AN_APPLICATION: "Bewerbung absenden",
    DOES_NOT_MATCH_FORMAT: "entspricht nicht dem {{format}}-Format",
    NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED:
      "nicht genügend Zeichen, mindestens {{count}} ist erforderlich",
    [tk(Tk.NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED, { plural: "one" })]:
      "nicht genügend Zeichen, mindestens {{count}} ist erforderlich",
    [tk(Tk.NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED, { plural: "other" })]:
      "nicht genügend Zeichen, mindestens {{count}} sind erforderlich",
    WHAT_IS_INCLUDED_IN_THE_SERVICE: "Was ist im Service enthalten",
    NO_INFORMATION_PROVIDED_AT_THIS_TIME: "derzeit keine Informationen verfügbar",
    MUST_BE_A_NUMBER: "muss eine Zahl sein",
    MUST_BE_GREATER_THAN_N: "muss größer als {{count}} sein",
    MUST_BE_AT_LEAST_N: "muss mindestens {{count}} sein",
    FIELD_CANNOT_BE_EMPTY: "Feld darf nicht leer sein",
    FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS:
      "Das Feld muss mindestens {{count}} Zeichen enthalten",
    FIELD_MUST_MATCH_FORMAT: "Das Feld muss dem {{format}}-Format entsprechen",
    FIELD_MUST_CONTAIN_A_NUMBER: "Das Feld muss eine Zahl enthalten",
    VALUE_MUST_BE_GREATER_THAN_N: "Der Wert muss größer als {{count}} sein",
    MINIMUM_VALUE_IS_N: "Der Mindestwert ist {{count}}",
    FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER:
      "Das Feld darf nicht mehr als {{count}} Zeichen enthalten",
    VALUE_MUST_BE_LESS_THAN_N: "Wert muss kleiner als {{count}} sein",
    MAXIMUM_VALUE_IS_N: "Maximalwert — {{count}}",
    PICK_A_DATE: "Datum wählen",
    HOW_DID_YOU_HEAR_ABOUT_US: "Wie haben Sie von uns erfahren",
    PLEASE_TELL_US_HOW_YOU_FOUND_OUT_ABOUT_US:
      "Bitte teilen Sie uns mit, wie Sie auf uns aufmerksam geworden sind",
    WEB_SEARCH: "Websuche",
    FRIEND_RECOMMENDATIONS: "Empfehlungen von Freunden",
    SOCIAL_MEDIA: "sozialen Medien",
    ADVERTISING: "Werbung",
    GENDER: "Geschlecht",
    MALE: "männliches",
    FEMALE: "weibliches",
    UNDETERMINED: "unbestimmtes",
    POSTAL_CODE: "Postleitzahl",
    BUILDING_TYPE: "Gebäudetyp",
    PRIVATE_HOUSE: "Privathaus",
    APARTMENT: "Wohnung",
    OFFICE: "Büro",
    AREA: "Fläche",
    M: "m",
    NUMBER_OF_ROOMS: "Anzahl der Zimmer",
    IS_THERE_AN_ATTIC: "Gibt es einen Dachboden",
    IS_THERE_A_BASEMENT: "Gibt es einen Keller",
    PLANNED_MOVING_DATE: "geplanter Umzugstermin",
    SELECTED_SERVICES: "ausgewählte Leistungen",
    MENU: "Menü",
    DASHBOARD: "Armaturenbrett",
    DOCUMENTATION: "Dokumentation",
    ADMINISTRATOR: "Administrator",
    A: "a",
    MY_PROFILE: "mein Profil",
    ORDER_MANAGEMENT: "Auftragsverwaltung",
    SERVICE_MANAGEMENT: "Serviceverwaltung",
    USER_MANAGEMENT: "Benutzerverwaltung",
    NEW: "neu",
    COMPLETED: "vollendet",
    REVENUE: "Einnahmen",
    SINCE_YESTERDAY: "seit gestern",
    LATEST_ORDERS: "Letzte Bestellungen",
    SHOW_ALL: "alle anzeigen",
    ID: "id",
    CLIENT: "Kunde",
    DATE: "Datum",
    SUM: "Summe",
    STATUS: "Status",
    IN_PROGRESS: "im Gange",
    ASSIGNED: "zugewiesen",
    CANCELLED: "abgesagt",
    ANNUAL_REVENUE: "Jahresumsatz",
    ADD_ORDER: "Bestellung hinzufügen",
    FILTER: "Filter",
    WITH_ELEVATOR: "mit Aufzug",
    WITHOUT_ELEVATOR: "ohne Aufzug",
    EDIT: "bearbeiten",
    DELETE: "löschen",
    YES: "Ja",
    NO: "Nein",
    ADD_A_SERVICE: "einen Dienst hinzufügen",
    NAME: "Name",
    CATEGORY: "Kategorie",
    [tk(Tk.CATEGORY, { plural: "one" })]: "Kategorie",
    [tk(Tk.CATEGORY, { plural: "other" })]: "Kategorien",
    PRICE: "Preis",
    ACTIVE: "aktiv",
    INACTIVE: "inaktiv",
    ADD_USER: "Benutzer hinzufügen",
    EMPLOYEE: "Mitarbeiter",
    USER: "Benutzer",
    [tk(Tk.USER, { plural: "one" })]: "Benutzer",
    [tk(Tk.USER, { plural: "other" })]: "Benutzer",
    ROLE: "Rolle",
    [tk(Tk.ROLE, { plural: "one" })]: "Rolle",
    [tk(Tk.ROLE, { plural: "other" })]: "Rollen",
    VIEW: "Sicht",
    ORDER_INFORMATION: "Bestellinformationen",
    CREATION_DATE: "Erstellungsdatum",
    TOTAL_COST: "Gesamtkosten",
    QUANTITY: "Menge",
    INFORMATION_NOT_PROVIDED: "Keine Informationen bereitgestellt",
    CHANGE_STATUS: "Status ändern",
    ACTIONS: "Aktionen",
    PRINT: "drucken",
    STATUS_SUCCESSFULLY_CHANGED: "Status erfolgreich geändert",
    FAILED_TO_CHANGE_STATUS: "Statusänderung fehlgeschlagen",
    THIS_ORDER_WAS_NOT_FOUND: "diese Bestellung wurde nicht gefunden",
    SERVICE_CATEGORY_MANAGEMENT: "Verwaltung von Servicekategorien",
    DESCRIPTION: "Beschreibung",
    ADD_CATEGORY: "Kategorie hinzufügen",
    THIS_ACTION_CANNOT_BE_UNDONE: "diese Aktion kann nicht rückgängig gemacht werden",
    NO_RECORDS_FOUND_IN_THE_DATABASE: "keine Datensätze in der Datenbank gefunden",
    NUMBER: "Nummer",
    SIZE: "Größe",
    CREATE: "erstellen",
    LANGUAGE: "Sprache",
    SELECT_THE_LANGUAGE_IN_WHICH_YOU_WANT_TO_PROVIDE_DATA_FOR_FILLING_IN:
      "Wählen Sie die Sprache aus, in der Sie Daten zur Vervollständigung bereitstellen möchten",
    SAVE: "speichern",
    RESET: "zurücksetzen",
    IMAGE: "Bild",
    ADD: "hinzufügen",
    HYPERLINK: "Hyperlink",
    CHANGES_SAVED_SUCCESSFULLY: "Änderungen erfolgreich gespeichert",
    FAILED_TO_SAVE_CHANGES: "Änderungen konnten nicht gespeichert werden",
    SERVICE: "Leistung",
    [tk(Tk.SERVICE, { plural: "one" })]: "Leistung",
    [tk(Tk.SERVICE, { plural: "other" })]: "Leistungen",
    THE_DATE_MUST_NOT_BE_IN_THE_PAST: "das Datum darf nicht in der Vergangenheit liegen",
    ORDER_REQUEST: "Bestellanfrage",
    PASSWORD: "Passwort",
    ADMINISTRATIVE_PANEL: "Verwaltungspanel",
    FORGOT_YOUR_PASSWORD: "Passwort vergessen",
    REMEMBER_ME: "erinnere dich an mich",
    SIGN_IN: "anmelden",
    FAILED_TO_LOG_IN: "Fehler bei der Anmeldung",
    AN_UNEXPECTED_ERROR_OCCURRED_PLEASE_TRY_AGAIN_LATER:
      "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal",
    INCORRECT_EMAIL_ADDRESS_AND_OR_PASSWORD: "falsche E-Mail-Adresse und/oder falsches Passwort",
    SIGN_OUT: "Ausloggen",
    FIRST_NAME: "Vorname",
    LAST_NAME: "Nachname",
    THIS_EMAIL_ADDRESS_IS_ALREADY_IN_USE_BY_ANOTHER_USER:
      "Diese E-Mail-Adresse wird bereits von einem anderen Benutzer verwendet",
    SUBJECT: "Betreff",
    BODY: "Text",
    SENDING_AN_EMAIL: "Senden einer E-Mail",
    EMAIL_SENT_SUCCESSFULLY: "E-Mail erfolgreich gesendet",
    SOME_OF_THE_SELECTED_ROLES_DO_NOT_EXIST: "einige der ausgewählten Rollen existieren nicht",
    INQUIRY: "Anfrage",
    [tk(Tk.INQUIRY, { plural: "one" })]: "Anfrage",
    [tk(Tk.INQUIRY, { plural: "other" })]: "Anfragen",
    FAILED_TO_LOAD_YOUR_DATA: "Ihre Daten konnten nicht geladen werden",
    ACCESS_TO_THE_PAGE_IS_DENIED: "Der Zugriff auf die Site-Seite wird verweigert",
    ONLY_ADMINISTRATORS_HAVE_ACCESS_TO_THIS_PAGE:
      "nur Administratoren haben Zugriff auf diese Seite",
    ONLY_ADMINISTRATORS_AND_EMPLOYEES_HAVE_ACCESS_TO_THIS_PAGE:
      "nur Administratoren und Mitarbeiter haben Zugriff auf diese Seite",
    YOU_ARE_ALREADY_LOGGED_IN: "Sie sind bereits angemeldet",
    AUTHENTICATION_SESSION_EXPIRED: "Authentifizierungssitzung abgelaufen",
    ORDERED_SERVICES: "bestellte Leistungen",
    THE_DATE_MUST_NOT_BE_EARLIER_THAN_THE_CURRENT_MOMENT:
      "das Datum darf nicht vor der aktuellen Uhrzeit liegen",
    YOU_HAVE_NOT_SELECTED_ANY_SERVICES: "Sie haben keine Dienste ausgewählt",
    VALUE_MUST_MATCH_PHONE_NUMBER_FORMAT: "Der Wert muss dem Telefonnummernformat entsprechen",
    "ENTER_THE_VALUE_IN_INTERNATIONAL_PHONE_NUMBER_FORMAT_I_E_...":
      "Geben Sie den Wert im internationalen Telefonnummernformat ein, d. h. +, Landesvorwahl und die Telefonnummer selbst (ohne Leerzeichen), zum Beispiel: +41791234567",
    ACCOUNT_LOGIN: "Konto-Login",
    "PROFESSIONAL_ORGANIZATION_OF_MOVING_TO_FROM_...":
      "Wir organisieren professionell Umzüge von/zu einer Wohnung, einem Büro oder einer Privatwohnung in der Schweiz. Schnell, sicher und unkompliziert. Planen Sie Ihren Umzug mit uns!",
    "MOVING_IN_SWITZERLAND_APARTMENT_MOVING_OFFICE...":
      "Umzüge Schweiz, Wohnungsumzüge, Büroumzüge, Privatumzüge, Wohnungsumzüge, Möbeltransporte Schweiz, Umzugsservice",
    INQUIRY_MANAGEMENT: "Anfragemanagement",
    RESOLVED: "gelöst",
    ADMINISTRATOR_COMMENT: "Administratorkommentar",
    RESOLVE: "lösen",
    INQUIRY_RESOLUTION: "Anfragelösung",
    REVIEW_MANAGEMENT: "Bewertungsmanagement",
    RATING: "Bewertung",
    PROS: "Für",
    CONS: "Wider",
    TEXT: "Text",
    REVIEW: "Bewertung",
    [tk(Tk.REVIEW, { plural: "one" })]: "Bewertung",
    [tk(Tk.REVIEW, { plural: "other" })]: "Bewertungen",
    FAILED_TO_OPEN_PRINT_WINDOW: "Druckfenster konnte nicht geöffnet werden",
    NEW_ORDER: "neue Bestellung",
    NEW_INQUIRY: "neue Anfrage",
    NEW_REVIEW: "neue Bewertung",
    SOMETHING_HAPPENED: "etwas ist passiert",
    MARK_AS_READ: "als gelesen markieren",
    FAILED_TO_MARK_NOTIFICATION_AS_READ:
      "Benachrichtigung konnte nicht als gelesen markiert werden",
    MARK_ALL_AS_READ: "alle als gelesen markieren",
    FAILED_TO_MARK_ALL_NOTIFICATIONS_AS_READ:
      "Fehler beim Markieren aller Benachrichtigungen als gelesen",
    NOTIFICATION: "Benachrichtigung",
    ORDER_CREATION: "Auftragserstellung",
    SERVICE_CREATION: "Serviceerstellung",
    CATEGORY_CREATION: "Kategorieerstellung",
    USER_CREATION: "Benutzererstellung",
    ORDER_CREATED: "Bestellung erstellt",
    SERVICE_CREATED: "Dienst erstellt",
    CATEGORY_CREATED: "Kategorie erstellt",
    USER_CREATED: "Vom Benutzer erstellt",
    INQUIRY_CREATED: "Anfrage erstellt",
    REVIEW_CREATED: "Bewertung erstellt",
    ORDER_REQUEST_CREATED: "Bestellanfrage erstellt",
    FAILED_TO_CREATE_ORDER: "Bestellung konnte nicht erstellt werden",
    FAILED_TO_CREATE_SERVICE: "Dienst konnte nicht erstellt werden",
    FAILED_TO_CREATE_CATEGORY: "Kategorie konnte nicht erstellt werden",
    FAILED_TO_CREATE_USER: "Benutzer konnte nicht erstellt werden",
    FAILED_TO_CREATE_INQUIRY: "Anfrage konnte nicht erstellt werden",
    FAILED_TO_CREATE_REVIEW: "Rezension konnte nicht erstellt werden",
    FAILED_TO_CREATE_ORDER_REQUEST: "Die Bestellanfrage konnte nicht erstellt werden",
    ORDER_DELETED: "Bestellung gelöscht",
    SERVICE_DELETED: "Dienst gelöscht",
    CATEGORY_DELETED: "Kategorie gelöscht",
    USER_DELETED: "Benutzer gelöscht",
    REVIEW_DELETED: "Bewertung gelöscht",
    INQUIRY_DELETED: "Anfrage gelöscht",
    FAILED_TO_DELETE_ORDER: "Bestellung konnte nicht gelöscht werden",
    FAILED_TO_DELETE_SERVICE: "Dienst konnte nicht gelöscht werden",
    FAILED_TO_DELETE_CATEGORY: "Kategorie konnte nicht gelöscht werden",
    FAILED_TO_DELETE_USER: "Benutzer konnte nicht gelöscht werden",
    FAILED_TO_DELETE_REVIEW: "Bewertung konnte nicht gelöscht werden",
    FAILED_TO_DELETE_INQUIRY: "Anfrage konnte nicht gelöscht werden",
    ORDER_NOT_FOUND: "Bestellung nicht gefunden",
    SERVICE_NOT_FOUND: "Dienst nicht gefunden",
    CATEGORY_NOT_FOUND: "Kategorie nicht gefunden",
    USER_NOT_FOUND: "Benutzer nicht gefunden",
    REVIEW_NOT_FOUND: "Bewertung nicht gefunden",
    INQUIRY_NOT_FOUND: "Anfrage nicht gefunden",
    NOTIFICATION_NOT_FOUND: "Benachrichtigung nicht gefunden",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_ORDER: "Möchten Sie die Bestellung wirklich löschen?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SERVICE: "Möchten Sie den Dienst wirklich löschen?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_CATEGORY: "Möchten Sie die Kategorie wirklich löschen?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_USER: "Möchten Sie den Benutzer wirklich löschen?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_REVIEW: "Möchten Sie die Bewertung wirklich löschen?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_INQUIRY: "Möchten Sie die Anfrage wirklich löschen?",
    ORDER_EDITING: "Bestellung bearbeiten",
    SERVICE_EDITING: "Service bearbeiten",
    CATEGORY_EDITING: "Kategorie bearbeiten",
    USER_EDITING: "Benutzer bearbeiten",
    REVIEW_EDITING: "Bewertung bearbeiten",
    INQUIRY_EDITING: "Anfrage bearbeiten",
    EDITING_ORDERED_SERVICES: "Bestellte Services bearbeiten",
    FAILED_TO_PRINT_ORDER: "Bestellung konnte nicht gedruckt werden",
    FAILED_TO_SEND_EMAIL: "E-Mail konnte nicht gesendet werden",
    FAILED_TO_SIGN_OUT: "Abmeldung fehlgeschlagen",
    CONTACT: "Kontakt",
    [tk(Tk.CONTACT, { plural: "one" })]: "Kontakt",
    [tk(Tk.CONTACT, { plural: "other" })]: "Kontakte",
    [tk(Tk.CONTACT, { context: "infinitive" })]: "Kontakt",
    YOU_HAVE_NO_NOTIFICATIONS: "Sie haben keine Benachrichtigungen",
    NO_REVIEWS_YET: "noch keine Bewertungen",
    WRITE_A_REVIEW: "eine Bewertung schreiben",
    WRITING_A_REVIEW: "Schreiben einer Rezension",
    ORDER_ID: "Bestellnummer",
    PAGE_NOT_FOUND: "Seite nicht gefunden",
    "IT_LOOKS_LIKE_THE_PAGE_...":
      "Es sieht so aus, als ob die gesuchte Seite an einen neuen Ort verschoben wurde. Aber keine Sorge, wir helfen Ihnen, den Weg zurück zu finden!",
    HOME: "Startseite",
    RETURN_TO_THE_MAIN_PAGE: "zurück zur Hauptseite",
    CALCULATE: "berechnen",
    CALCULATE_THE_COST_OF_MOVING: "Berechnen Sie die Kosten für den Umzug",
    GO_TO: "gehe zu",
    PERSONAL_DATA_UPDATED: "personenbezogene Daten aktualisiert",
    FAILED_TO_UPDATE_PERSONAL_DATA: "Fehler beim Aktualisieren der persönlichen Daten",
    ROLE_DATA_UPDATED: "Rollendaten aktualisiert",
    FAILED_TO_UPDATE_ROLE_DATA: "Fehler beim Aktualisieren der Rollendaten",
    PAID: "bezahlte",
    UNPAID: "unbezahlte",
    ONLY_IMAGES_IN_JPG_PNG_SVG_FORMATS_ARE_ACCEPTED:
      "Es werden nur Bilder in den Formaten {{formats}} akzeptiert",
    FAILED_TO_SAVE_IMAGE: "Bild konnte nicht gespeichert werden",
    FAILED_TO_DELETE_PREVIOUS_IMAGE: "Das Löschen des vorherigen Bildes ist fehlgeschlagen",
    ARE_YOU_SURE_YOU_WANT_TO_CLEAR_FORM_DATA: "Möchten Sie die Formulardaten wirklich löschen?",
    MAX: "max",
    REVIEW_DETAILS: "Bewertungsdetails",
    ORDER_NUMBER: "Bestellnummer",
    "NO.": "Nr.",
    OPEN_NAVIGATION_MENU: "Navigationsmenü öffnen",
    CLOSE_NAVIGATION_MENU: "Navigationsmenü schließen",
    PLEASE_PROVIDE_THIS_INFORMATION_ONLY_IF_YOU_WOULD_LIKE_US_TO_CONTACT_YOU:
      "Bitte geben Sie diese Informationen nur an, wenn Sie möchten, dass wir Sie kontaktieren.",
    THIS_INFORMATION_WILL_NOT_BE_AVAILABLE_PUBLICLY:
      "Diese Informationen werden nicht öffentlich zugänglich sein.",
    OPTIONAL: "optional",
    PLEASE_PROVIDE_AT_LEAST_ONE_CONTACT_INFORMATION:
      "Bitte geben Sie mindestens eine Kontaktinformation an",
    ORDER_DETAILS: "Bestelldetails",
    ORDER_SUMMARY: "Bestellübersicht",
    CUSTOMER_SUPPORT: "Kundensupport",
    APPROVED: "freigegeben",
    REJECTED: "abgelehnt",
    APPROVE: "genehmigen",
    DISAPPROVE: "missbilligen",
    REVIEW_SUCCESSFULLY_APPROVED: "Bewertung wurde erfolgreich freigegeben",
    FAILED_TO_APPROVE_REVIEW: "Freigabe der Bewertung fehlgeschlagen",
    MY_ORDERS: "Meine Bestellungen",
    DELETE_ALL: "Alle löschen",
    "THIS_IS_SIMPLY_A_LIST_OF_ORDERS...":
      "Dabei handelt es sich lediglich um eine auf Ihrem Gerät gespeicherte Liste der Bestellungen, sodass Sie jederzeit detaillierte Informationen zu jeder Bestellung einsehen können.",
    "DELETING_A_SPECIFIC_OR_ALL_ORDERS...":
      "Durch das Löschen einiger oder aller Bestellungen werden nur die entsprechenden Daten von Ihrem Gerät gelöscht. Die in der Datenbank gespeicherten Daten bleiben erhalten.",
    "IF_YOU_NEED_TO_CHANGE_ANY_INFORMATION...":
      "Wenn Sie Informationen zu Ihrer Bestellung ändern oder diese stornieren möchten, kontaktieren Sie uns bitte.",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALL_ORDERS: "Möchten Sie wirklich alle Bestellungen löschen?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ORDER_N:
      "Möchten Sie Bestellung Nr. {{number}} wirklich löschen?",
    YOU_HAVEN_T_CREATED_ANY_ORDERS_YET: "Sie haben noch keine Bestellungen erstellt",
    "YOUR_REVIEW_WILL_BE_PUBLISHED_AFTER...":
      "Ihre Bewertung wird nach Prüfung durch den Administrator veröffentlicht",
    CHANGE_PASSWORD: "Passwort ändern",
    PASSWORD_CHANGE: "Passwortänderung",
    CURRENT_PASSWORD: "Aktuelles Passwort",
    NEW_PASSWORD: "neues Passwort",
    REPEAT_NEW_PASSWORD: "neues Passwort wiederholen",
    PASSWORDS_DO_NOT_MATCH: "Passwörter stimmen nicht überein",
    PASSWORD_CHANGED: "Passwort geändert",
    FAILED_TO_CHANGE_PASSWORD: "Passwort konnte nicht geändert werden",
    CURRENT_PASSWORD_IS_INCORRECT: "aktuelles Passwort ist falsch",
    INSUFFICIENT_RIGHTS_TO_PERFORM_THIS_ACTION:
      "nicht genügend Rechte, um diese Aktion auszuführen",
    CASH_PAYMENT_IS_POSSIBLE: "Barzahlung ist möglich",
    WE_HAVE_SPECIAL_OFFERS_FOR_SENIORS: "Wir haben spezielle Angebote für Senioren",
    WE_PROVIDE_A_10_DISCOUNT_FOR_STUDENTS: "Wir bieten 10% Rabatt für Studenten",
    ABOUT_US: "über uns",
    PASSWORD_RESET: "Passwortzurücksetzung",
    "ENTER_THE_EMAIL_ADDRESS_ASSOCIATED_WITH_YOUR_ACCOUNT...":
      "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein und wir senden Ihnen eine E-Mail mit einem neuen Passwort",
    RESET_PASSWORD: "Passwort zurücksetzen",
    PASSWORD_RESET_SUCCESSFUL: "Passwort erfolgreich zurückgesetzt",
    AN_EMAIL_WITH_A_NEW_PASSWORD_HAS_BEEN_SENT_TO_YOUR_ADDRESS:
      "Eine E-Mail mit einem neuen Passwort wurde an Ihre Adresse gesendet",
    FAILED_TO_SEND_PASSWORD_RESET_REQUEST:
      "Fehler beim Senden der Anfrage zum Zurücksetzen des Passworts",
    AN_ACCOUNT_WITH_THE_SPECIFIED_EMAIL_ADDRESS_WAS_NOT_FOUND:
      "Es wurde kein Konto mit der angegebenen E-Mail-Adresse gefunden",
    ABOUT_US_CHAPTER_1_TITLE: "IHR ZUHAUSE - UNSER JOB",
    ABOUT_US_CHAPTER_1_PARAGRAPH:
      "Wir sorgen dafür, dass Ihr Umzug reibungslos verläuft. Egal, ob Sie in eine neue Stadt ziehen, Ihr erstes eigenes Zuhause beziehen oder mit Ihrer Familie mehr Platz brauchen – <strong>wir machen Ihren Umzug einfach und für Sie vor allem stressfrei</strong>.",
    ABOUT_US_CHAPTER_2_TITLE: "IHR UNTERNEHMEN - UNSER JOB",
    ABOUT_US_CHAPTER_2_PARAGRAPH_1:
      "<strong>Ein Umzug mit dem Unternehmen kann eine grosse Herausforderung sein</strong>.",
    ABOUT_US_CHAPTER_2_PARAGRAPH_2:
      "Da ist es hilfreich einen kompetenten und erfahrenen Partner an der Seite zu wissen. Wir sind darauf spezialisiert, Firmenumzüge effizient und mit minimaler Ausfallzeit durchzuführen. Kümmern Sie sich um Ihr Kerngeschäft, wir übernehmen den Rest für Sie.",
    ABOUT_US_CHAPTER_3_TITLE: "ENTSORGUNGEN",
    ABOUT_US_CHAPTER_3_PARAGRAPH_1: "<strong>Platz schaffen ohne Stress</strong>.",
    ABOUT_US_CHAPTER_3_PARAGRAPH_2:
      "Alte Möbel, Elektrogeräte oder kaputte Gegenstände? Was auch immer entsorgt werden muss, wir übernehmen die <strong>umweltfreundliche und fachgerechte Entsorgung</strong> für Sie. Ob nach einem Umzug, einer Haushaltsauflösung oder weil Sie mehr Platz benötigen – wir kümmern uns darum, dass alles ordnungsgemäss entsorgt wird.",
    ABOUT_US_CHAPTER_4_TITLE: "ÜBER HEGI UMZÜGE",
    ABOUT_US_CHAPTER_4_PARAGRAPH_1:
      "Wir sind ein junges, energiegeladenes Team, das danach strebt, ein zuverlässiger Partner in der Relocation-Branche zu werden. Obwohl wir erst vor kurzem gegründet wurden, verfügen wir über einen reichen Erfahrungsschatz, den wir bei führenden Unternehmen der Branche erworben haben. Wir wissen, wie man einen Umzug so organisiert, dass er für den Kunden schnell, sicher und stressfrei verläuft.",
    ABOUT_US_CHAPTER_4_PARAGRAPH_2:
      "Mit der Gründung unseres eigenen Unternehmens haben wir die besten Praktiken und Ideen kombiniert, um unseren Service auf die nächste Stufe zu heben. Unser Ziel ist es nicht nur, Dinge zu bewegen, sondern den Menschen in einer wichtigen Phase ihres Lebens Vertrauen und Sicherheit zu geben. Wir wachsen, wir lernen, und wir werden jeden Tag besser - zum Wohle derer, die uns ihren Umzug anvertrauen.",
    SHOW_MY_ORDERS: "meine Bestellungen anzeigen",
    HIDE_MY_ORDERS: "meine Bestellungen verbergen",
    QR_CODE_TO_GO_TO_THIS_SITE: "QR-Code, um zu dieser Site zu gelangen",
    ALL_SERVICES_BELONGING_TO_THIS_CATEGORY_WILL_BE_DELETED:
      "Alle Dienste, die zu dieser Kategorie gehören, werden gelöscht",
    THE_ORDER_CANNOT_BE_UPDATED_BECAUSE_IT_HAS_ALREADY_BEEN_FULFILLED:
      "Die Bestellung kann nicht mehr aktualisiert werden, da sie bereits ausgeführt wurde",
    CHANGE_OF_STATUS: "Statusänderung",
    THE_ORDER_STATUS_IS_COMPLETED_ARE_YOU_SURE_YOU_WANT_TO_CHANGE_IT_TO_NEW:
      "Der Auftragsstatus lautet „{{current}}“. Möchten Sie ihn wirklich auf „{{new}}“ ändern?",
    CHANGE_PAYMENT_STATUS: "Zahlungsstatus ändern",
    PAYMENT_STATUS_CHANGE: "Änderung des Zahlungsstatus",
    PAYMENT_STATUS_CHANGED: "Zahlungsstatus geändert",
    FAILED_TO_CHANGE_PAYMENT_STATUS: "Zahlungsstatus konnte nicht geändert werden",
    MOST_LIKELY_IT_WAS_DELETED: "Es wurde höchstwahrscheinlich gelöscht",
    SETTINGS: "Einstellungen",
    CLOSE: "schließen",
    CONSENT_MODAL_TITLE: "Wir verwenden Cookies",
    CONSENT_MODAL_DESCRIPTION:
      "Wir verwenden Cookies, um unsere Website zu betreiben und Anzeigen über Google Ads anzuzeigen und zu analysieren. Essenzielle Cookies werden immer verwendet. Alle anderen Cookies werden nur mit Ihrer Zustimmung verwendet. Sie können alle Cookies akzeptieren, optionale Cookies ablehnen oder Ihre Einstellungen anpassen.",
    CONSENT_MODAL_ACCEPT_ALL: "Alle akzeptieren",
    CONSENT_MODAL_ACCEPT_NECESSARY: "Akzeptiere nur das Notwendige",
    CONSENT_PREFERENCES_MODAL_TITLE: "Cookie-Einstellungen",
    CONSENT_PREFERENCES_MODAL_SAVE_PREFERENCES: "Akzeptieren",
    CONSENT_PREFERENCES_MODAL_SERVICE: "Dienst(e)",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_TITLE: "Notwendig",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_DESCRIPTION:
      "Diese Cookies sind für das ordnungsgemäße Funktionieren der Website erforderlich, beispielsweise zur Authentifizierung von Benutzern.",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_TITLE: "Analyse",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_DESCRIPTION:
      "Analyse-Cookies helfen dabei, Daten zu sammeln, die es Diensten ermöglichen zu verstehen, wie Nutzer mit einem bestimmten Dienst interagieren.",
    CONSENT_PREFERENCES_MODAL_SERVICE_ANALYTICS_STORAGE:
      "Erlaubt die Speicherung von Daten (z. B. Cookies) für Analysezwecke, etwa zur Messung der Besuchsdauer.",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_TITLE: "Werbung",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_DESCRIPTION:
      "Google verwendet Cookies für Werbezwecke, einschließlich der Anzeige und Bereitstellung von Werbung, der Personalisierung von Anzeigen, der Begrenzung der Häufigkeit, mit der Anzeigen angezeigt werden, der Deaktivierung unerwünschter Anzeigen sowie der Messung der Wirksamkeit von Werbung.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_STORAGE:
      "Erlaubt die Speicherung von Daten (z. B. Cookies) für Werbezwecke.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_USER_DATA:
      "Erlaubt die Übermittlung werberelevanter Nutzerdaten an Google.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_PERSONALIZATION:
      "Erlaubt die Nutzung von Daten für personalisierte Werbung.",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_TITLE: "Funktionalität",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_DESCRIPTION:
      "Funktionale Cookies ermöglichen es Nutzern, mit einem Dienst oder einer Website zu interagieren und auf Funktionen zuzugreifen, die für diesen Dienst wesentlich sind.",
    CONSENT_PREFERENCES_MODAL_SERVICE_FUNCTIONALITY_STORAGE:
      "Ermöglicht die Speicherung von Daten zur Unterstützung der Funktionalität von Websites oder Anwendungen, beispielsweise Spracheinstellungen.",
    CONSENT_PREFERENCES_MODAL_SERVICE_PERSONALIZATION_STORAGE:
      "Ermöglicht die Speicherung von Daten für Personalisierungszwecke, beispielsweise Empfehlungen.",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_TITLE: "Sicherheit",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_DESCRIPTION:
      "Cookies für Sicherheitszwecke, beispielsweise zur Authentifizierung von Nutzern, zur Betrugsprävention und zum Schutz von Nutzern bei der Nutzung des Dienstes.",
    CONSENT_PREFERENCES_MODAL_SERVICE_SECURITY_STORAGE:
      "Ermöglicht die Speicherung sicherheitsrelevanter Daten, beispielsweise für Authentifizierung, Betrugsprävention und andere Schutzfunktionen für Nutzer.",
    THE_PAGE_LANGUAGE_HAS_CHANGED_BUT_THE_CONTENTS:
      "Die Seitensprache hat sich geändert, der Inhalt des Cookie-Dialogfelds wird jedoch erst nach dem Neuladen der Seite aktualisiert.",
    IF_YOU_ARE_NOT_INTERESTED_IN_THE_CONTENTS:
      "Wenn Sie am Inhalt des Cookie-Dialogfelds nicht interessiert sind, können Sie diese Meldung ignorieren.",
    RELOAD_PAGE: "Seite neu laden",
    CONSENT_SUMMARY_TITLE: "Einwilligungsstatus für die Datenverarbeitung",
    CONSENT_SUMMARY_DESCRIPTION:
      "Eine kurze Übersicht über Ihren aktuellen Einwilligungsstatus. Detaillierte Informationen sind in den Einstellungen verfügbar.",
    CONSENT_ID: "Einwilligungs-ID",
    LAST_MODIFIED: "zuletzt geändert",
    CONSENT_SUMMARY_ALLOWED: "erlaubt",
    CONSENT_SUMMARY_PARTIALLY_ALLOWED: "teilweise erlaubt",
    CONSENT_SUMMARY_BLOCKED: "blockiert",
  } satisfies Record<Tk, string>,
} satisfies ResourceLanguage;

export { RESOURCES };
